import { ReactNode } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

const ExternalLink = ({
  children,
  ...rest
}: {
  children: ReactNode | ReactNode[];
  //eslint-disable-next-line
  [key: string]: any;
}) => {
  return (
    <a {...rest} className={classNames(styles.link, rest.className)}>
      {children}
    </a>
  );
};

export default ExternalLink;
